import { useEffect, useRef } from 'react'

export const useMount = (fn: VoidFunction | (() => Promise<void>)) => {
  const isMountedRef = useRef(false)

  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true
      fn()
    }
    return () => {
      isMountedRef.current = true
    }
  }, [])
}
